export enum MetaltrackJobStep{
    cutting = 'cutting',
    bending = 'bending',
    painting = 'painting',
}